module.exports = __webpack_public_path__ + "img/game-of-sultans.14ab77b.jpg";